import { fetchUtils } from 'react-admin';
import type { ClicksByReferrersResource } from '../../../Entities/ClicksByReferrer';
import create from '../../create';
import type { JsonApiResource } from '../../JsonApiTypes';
import type { AuthProvider } from '../../AuthProvider';

export interface ReportClickReferrerCreateParams {
  from: string;
  to: string;
  regionIds?: number[];
}
export interface ReportClickReferrerCreateResult {
  data: ClicksByReferrersResource[];
  prefetched: Record<string, JsonApiResource[]>;
}
export type ReportClickReferrerCreate = (
  params: ReportClickReferrerCreateParams,
) => Promise<ReportClickReferrerCreateResult>;

export default function clickReferrerCreate(
  apiUrl: string,
  httpClient = fetchUtils.fetchJson,
  canAccess: typeof AuthProvider.canAccess = async () => true,
): ReportClickReferrerCreate {
  const createRecord = create(apiUrl, httpClient);
  return async (params) => {
    const prefetch = [];

    if (await canAccess({ resource: 'clicks_by_referrers', action: 'list' })) {
      prefetch.push('results');
    }
    if (await canAccess({ resource: 'regions', action: 'list' })) {
      prefetch.push('results.region');
    }

    const result = await createRecord('reports', {
      data: {
        attributes: {
          report_type_id: 2,
          from: params.from,
          to: params.to,
          ...(params.regionIds?.length ? { region_ids: params.regionIds } : {}),
        },
      },
      meta: { prefetch },
    });
    const prefetched = (result.meta?.prefetched ?? {}) as Record<string, JsonApiResource[]>;
    return {
      data: (prefetched.clicks_by_referrers ?? []) as ClicksByReferrersResource[],
      prefetched,
    };
  };
}
